import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabIVB as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabIVB = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const graduatedNonRigorousField = () => {
    const propertyName = pn<AprResponseModel>("graduatedNonRigorous");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.graduatedNonRigorous}{" "}
        {formatPercentTotal(props.data?.graduatedNonRigorous, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const graduatedRigorousField = () => {
    const propertyName = pn<AprResponseModel>("graduatedRigorous");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.graduatedRigorous}{" "}
        {formatPercentTotal(props.data?.graduatedRigorous, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const graduatedLateField = () => {
    const propertyName = pn<AprResponseModel>("graduatedLate");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.graduatedLate} {formatPercentTotal(props.data?.graduatedLate, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const alternativeCredentialField = () => {
    const propertyName = pn<AprResponseModel>("alternativeCredential");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.alternativeCredential}{" "}
        {formatPercentTotal(props.data?.alternativeCredential, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const dropOuts4BField = () => {
    const propertyName = pn<AprResponseModel>("dropOuts4B");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.dropOuts4B} {formatPercentTotal(props.data?.dropOuts4B, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const deceased4BField = () => {
    const propertyName = pn<AprResponseModel>("deceased4B");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.deceased4B} {formatPercentTotal(props.data?.deceased4B, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const other4BField = () => {
    const propertyName = pn<AprResponseModel>("other4B");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.other4B} {formatPercentTotal(props.data?.other4B, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknown4BField = () => {
    const propertyName = pn<AprResponseModel>("unknown4B");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.unknown4B} {formatPercentTotal(props.data?.unknown4B, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const secondaryDropoutsField = () => {
    const propertyName = pn<AprResponseModel>("secondaryDropouts");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.secondaryDropouts}{" "}
        {formatPercentTotal(props.data?.secondaryDropouts, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Educational Status of High School Seniors</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              {props.data?.graduatedNonRigorous != null && (
                <Grid item xs={12}>
                  {graduatedNonRigorousField()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.graduatedRigorous != null && (
                <Grid item xs={12}>
                  {graduatedRigorousField()}
                </Grid>
              )}

              {props.data?.graduatedLate != null && (
                <Grid item xs={12}>
                  {graduatedLateField()}
                </Grid>
              )}

              {props.data?.alternativeCredential != null && (
                <Grid item xs={12}>
                  {alternativeCredentialField()}
                </Grid>
              )}

              {props.data?.dropOuts4B != null && (
                <Grid item xs={12}>
                  {dropOuts4BField()}
                </Grid>
              )}

              {props.data?.deceased4B != null && (
                <Grid item xs={12}>
                  {deceased4BField()}
                </Grid>
              )}

              {props.data?.other4B != null && (
                <Grid item xs={12}>
                  {other4BField()}
                </Grid>
              )}

              {props.data?.unknown4B != null && (
                <Grid item xs={12}>
                  {unknown4BField()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />

              {props.data?.secondaryDropouts != null && (
                <Grid item xs={12}>
                  {secondaryDropoutsField()}
                </Grid>
              )}
            </Grid>
          </Grid>

          <GridBreak />

          {/* <Grid item xs={6}>
            <PieChart
              id="pie-tab-a"
              dataSource={props.data?.chartValues}
              palette="Bright"
              title="Participants"
              width="100%"
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid> */}
        </Grid>
      </Stack>
    </Card>
  );
};
